import Typography from '../Typography';
import NoDataSvg from './NoDataSvg';

const NoData = ({ compact, message }: { compact?: boolean; message?: string }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center animated fadeIn duration-200 gap-4 ${
        compact ? '' : 'py-10 min-h-full flex-1'
      }`}
    >
      <NoDataSvg />
      {/* <Image src={NoResult} alt="no-result" />*/}
      {/* <ImagePlaceholder /> */}
      <Typography variant='regular' weight={600}>
        <span>{message || 'Sorry! No results found'}</span>
      </Typography>
    </div>
  );
};

export default NoData;
